<ion-list lines="none" class="suggestion-list">
  <ion-item
    *ngFor="let item of items; let i = index"
    button
    (click)="selectItem(i)"
    [class.is-selected]="i === selectedIndex"
    class="suggestion-item"
  >
    <ion-icon [name]="item.icon" slot="start" class="item-icon"></ion-icon>
    <ion-label class="item-label">{{ item.title }}</ion-label>
  </ion-item>
  <ion-item *ngIf="items.length === 0" class="no-results">
    <ion-label>No results</ion-label>
  </ion-item>
</ion-list>
